<!-- src/components/SideDrawer.vue -->
<template>
  <transition name="fade">
    <div v-if="open" class="drawer-backdrop" @click.self="$emit('close')">
      <transition name="slide">
        <aside
          class="side-drawer"
          role="navigation"
          aria-label="أهلا وسهلا بكم"
        >
          <!-- Header -->
          <header class="drawer-header">
            <h2>أهلا وسهلا بكم</h2>
            <button class="btn close-btn" aria-label="إغلاق" @click="$emit('close')">
              <i class="fas fa-times"></i>
            </button>
          </header>

          <!-- Home -->
          <nav class="drawer-nav">
            <router-link to="/" class="drawer-item" @click="$emit('close')">
              <i class="fas fa-home"></i>
              <span>الصفحة الرئيسية</span>
            </router-link>

            <hr/>

            <!-- تواصل مع المطوّر -->
            <section class="section">
              <p class="section-title">تواصل مع المطوّر</p>
              <div class="social-grid">
                <button class="social-btn whatsapp" @click="contactWhatsApp">
                  <i class="fab fa-whatsapp"></i>
                  <span>واتساب</span>
                </button>
                <button class="social-btn sms" @click="contactSMS">
                  <i class="fas fa-sms"></i>
                  <span>رسالة نصية</span>
                </button>
                
              </div>
            </section>

            <hr/>

              <!-- مشاركة التطبيق -->
            <section class="section">
              <p class="section-title">مشاركة التطبيق</p>
              <div class="social-grid">
                <button class="social-btn whatsapp" @click="shareWhatsApp">
                  <i class="fab fa-whatsapp"></i>
                  <span>واتساب</span>
                </button>
                <button class="social-btn messenger" @click="shareMessenger">
                  <i class="fab fa-facebook-messenger"></i>
                  <span>مسنجر</span>
                </button>
                <button class="social-btn telegram" @click="shareTelegram">
                  <i class="fab fa-telegram-plane"></i>
                  <span>تليجرام</span>
                </button>
              </div>
            </section>

            <hr class="divider" />

            <!-- زر صفحة المطوّر -->

            <!-- زر صفحة المطوّر -->
            <!-- <button
              type="button"
              class="drawer-item dev-btn"
              @click="devModalOpen = true"
            >
              <i class="fas fa-user-shield"></i>
              <span>أعمالنا  </span>
            </button> -->
          </nav>
        </aside>
      </transition>
    </div>
  </transition>

  <!-- نافذة صفحة المطوّر
  <DevModal
    v-if="devModalOpen"
    @close="devModalOpen = false"
  /> -->
</template>

<script>

// import DevModal from './DevModal.vue'

export default {
  name: 'SideDrawer',
  // components: { DevModal },
  props: {
    open: { type: Boolean, required: true }
  },
  data() {
    return {
      devModalOpen: false,
      devPhone: '0953447860',
      telegramUser: 'YourTelegramUsername',
      appUrl: window.location.origin,
      shareText: 'جرب هذا التطبيق الرائع!'
    }
  },
  methods: {
    contactWhatsApp() {
      const url = `https://wa.me/${this.devPhone}`
      window.open(url, '_blank')
    },
    contactSMS() {
      const url = `sms:${this.devPhone}?body=${encodeURIComponent('مرحباً')}`
      window.open(url)
    },
    contactTelegram() {
      const url = `https://t.me/${this.telegramUser}`
      window.open(url, '_blank')
    },
    shareWhatsApp() {
      const url = `https://wa.me/?text=${encodeURIComponent(this.shareText + ' ' + this.appUrl)}`
      window.open(url, '_blank')
    },
    shareMessenger() {
      const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.appUrl)}`
      window.open(url, '_blank')
    },
    shareTelegram() {
      const url = `https://t.me/share/url?url=${encodeURIComponent(this.appUrl)}&text=${encodeURIComponent(this.shareText)}`
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
/* خلفية التعتيم */
.drawer-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.55);
  backdrop-filter: blur(6px) saturate(120%);
  display: flex;
  justify-content: flex-start;
  z-index: 2000;
  transition: opacity 0.3s ease;
}

/* حركة الانزلاق */
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}
.slide-enter-from,
.slide-leave-to {
  transform: translateX(-100%);
}

/* الحاوية */
.side-drawer {
  width: 320px;
  max-width: 85%;
  background: rgba(30,30,30,0.92);
  backdrop-filter: blur(12px);
  border-right: 1px solid rgba(255,255,255,0.08);
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 1.2rem;
  box-shadow: 6px 0 28px rgba(0,0,0,0.55);
  font-family: 'Cairo', sans-serif;
  color: #f3f4f6;
  animation: fadeIn 0.4s ease;
}

/* الهيدر */
.drawer-header h2 {
  margin: 0;
  font-size: 1.45rem;
  font-weight: 800;
  background: linear-gradient(90deg, #2563eb, #60a5fa);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: 0.5px;
}
.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #60a5fa;
  cursor: pointer;
  transition: transform 0.25s ease, color 0.25s ease;
}
.close-btn:hover {
  transform: rotate(90deg) scale(1.15);
  color: #93c5fd;
}

/* الروابط */
.drawer-item {
  display: flex;
  align-items: center;
  gap: 0.9rem;
  padding: 0.7rem 0.6rem;
  border-radius: 10px;
  color: #f3f4f6;
  text-decoration: none;
  font-weight: 600;
  transition: background 0.25s, transform 0.2s;
}
.drawer-item i {
  width: 24px;
  text-align: center;
  color: #60a5fa;
  transition: color 0.25s, transform 0.25s;
}
.drawer-item:hover {
  background: rgba(96,165,250,0.12);
  transform: translateX(6px);
}
.drawer-item:hover i {
  color: #93c5fd;
  transform: scale(1.2);
}

/* الفواصل */
.divider {
  border: none;
  height: 1px;
  background: linear-gradient(90deg, transparent, #60a5fa, transparent);
  margin: 1.2rem 0;
}

/* العناوين الفرعية */
.section-title {
  margin: 0 0 0.6rem;
  font-size: 1rem;
  font-weight: 700;
  color: #60a5fa;
  letter-spacing: 0.3px;
}

/* أزرار التواصل */
.social-grid {
  display: flex;
  gap: 0.7rem;
}
.social-btn {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border: none;
  border-radius: 10px;
  padding: 0.55rem;
  font-size: 0.95rem;
  cursor: pointer;
  transition: transform 0.25s, box-shadow 0.25s;
  color: #fff;
  font-weight: 600;
  background: linear-gradient(135deg, #2563eb, #1e40af);
}
.social-btn i {
  font-size: 1.2rem;
}
.social-btn:hover {
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 6px 18px rgba(0,0,0,0.35);
}

/* ألوان مخصصة */
.whatsapp { background: linear-gradient(135deg, #25D366, #128C7E); }
.sms      { background: linear-gradient(135deg, #007bff, #0056b3); }
.telegram { background: linear-gradient(135deg, #0088cc, #005f8f); }
.messenger{ background: linear-gradient(135deg, #0084FF, #005bb5); }

/* حركات */
@keyframes fadeIn {
  from { opacity: 0; transform: translateX(-20px); }
  to   { opacity: 1; transform: translateX(0); }
}


</style>
